import { useTheme } from '../ThemeContext';

export default function Paywall({ onGoToBilling, trialExpiredAt }) {
  const { t } = useTheme();
  const s = getS(t);

  const expiredDate = trialExpiredAt
    ? new Date(trialExpiredAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : null;

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.iconWrap}>
          <span style={s.icon}>🔒</span>
        </div>

        <h2 style={s.heading}>Your free trial has ended</h2>

        {expiredDate && (
          <p style={s.expiredNote}>Trial expired {expiredDate}</p>
        )}

        <p style={s.body}>
          Upgrade to a paid plan to continue accessing TrackShop. Your jobs, customers,
          and all your data are safe — they'll be waiting when you upgrade.
        </p>

        <button onClick={onGoToBilling} style={s.btn}>
          View Plans &amp; Upgrade
        </button>

        <div style={s.plans}>
          {[
            { name: 'Starter', price: '$199', detail: '/month' },
            { name: 'Professional', price: '$349', detail: '/month', highlight: true },
            { name: 'Enterprise', price: 'Contact us', detail: '' },
          ].map(({ name, price, detail, highlight }) => (
            <div
              key={name}
              style={{
                ...s.planChip,
                ...(highlight ? s.planChipHighlight : {}),
              }}
            >
              <span style={s.planName}>{name}</span>
              <span style={s.planPrice}>{price}<span style={s.planDetail}>{detail}</span></span>
            </div>
          ))}
        </div>

        <p style={s.footer}>
          Questions?{' '}
          <a href="mailto:hello@trackshop.io" style={s.link}>hello@trackshop.io</a>
        </p>
      </div>
    </div>
  );
}

const getS = (t) => ({
  page: {
    minHeight: 'calc(100vh - 56px)',
    backgroundColor: t.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  card: {
    backgroundColor: t.card,
    border: `1px solid ${t.border1}`,
    borderRadius: 16,
    padding: '48px 48px 40px',
    maxWidth: 480,
    width: '100%',
    boxShadow: t.shadowMd,
    textAlign: 'center',
  },
  iconWrap: {
    marginBottom: 20,
  },
  icon: {
    fontSize: 40,
  },
  heading: {
    margin: '0 0 8px',
    fontSize: 24,
    fontWeight: 800,
    color: t.text1,
    letterSpacing: '-0.02em',
  },
  expiredNote: {
    margin: '0 0 16px',
    fontSize: 13,
    color: t.text4,
  },
  body: {
    margin: '0 0 28px',
    fontSize: 15,
    color: t.text3,
    lineHeight: 1.6,
  },
  btn: {
    display: 'block',
    width: '100%',
    padding: '13px 0',
    backgroundColor: '#D97706',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 28,
    transition: 'background-color 0.15s ease',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  plans: {
    display: 'flex',
    gap: 8,
    justifyContent: 'center',
    marginBottom: 24,
  },
  planChip: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    padding: '10px 8px',
    border: `1px solid ${t.border1}`,
    borderRadius: 8,
    backgroundColor: t.card2,
  },
  planChipHighlight: {
    border: '1px solid #D97706',
    backgroundColor: t.amberBg,
  },
  planName: {
    fontSize: 11,
    fontWeight: 700,
    color: t.text4,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  planPrice: {
    fontSize: 15,
    fontWeight: 800,
    color: t.text1,
  },
  planDetail: {
    fontSize: 11,
    fontWeight: 500,
    color: t.text4,
  },
  footer: {
    margin: 0,
    fontSize: 13,
    color: t.text4,
  },
  link: {
    color: '#D97706',
    fontWeight: 600,
    textDecoration: 'none',
  },
});
